import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import t from '@/store/types';

export const mapStateToProps = (state: unknown, props: unknown) => {
  return {};
};

export const mapDispatchToProps = (dispatch: Dispatch) => ({
  openDialog: (name: string, payload?: unknown) =>
    dispatch({ type: t.OPEN_DIALOG, name, payload }),
  closeDialog: (name: string, payload?: unknown) =>
    dispatch({ type: t.CLOSE_DIALOG, name, payload }),
});

export default connect(null, mapDispatchToProps);
